import { AudioData } from './AudioData';
import { AudioDataSource } from './AudioDataSource';

export class BufferAudioData extends AudioData {
  private static _audio: HTMLAudioElement = new Audio();
  private static _unsupported: string = '';
  private static _emptySound: Float32Array = new Float32Array(1);

  public static async Load(
    context: BaseAudioContext,
    sources: AudioDataSource[],
    shouldBeDisposed: boolean = false
  ): Promise<BufferAudioData | null> {
    for (const source of sources) {
      try {
        if (BufferAudioData._audio.canPlayType(source.type) === BufferAudioData._unsupported) {
          continue;
        }

        const response = await fetch(source.uri);
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const arrayBuffer = await response.arrayBuffer();
        const buffer = await context.decodeAudioData(arrayBuffer);

        return new BufferAudioData(buffer, shouldBeDisposed);
      } catch (e) {
        console.warn(`Can't decode audio buffer from ${source.uri}. Trying next source.`, e);
      }
    }

    console.warn("Can't decode audio buffer from any source. ignoring.");
    return null;
  }

  public buffer: AudioBuffer | null = null;
  private _shouldBeDisposed: boolean;

  constructor(buffer: AudioBuffer, shouldBeDisposed: boolean = false) {
    super();
    this.buffer = buffer;
    this._shouldBeDisposed = shouldBeDisposed;
  }

  public dispose(): void {
    if (this._shouldBeDisposed) {
      try {
        if (BufferAudioData._emptySound && this.buffer?.copyToChannel) {
          for (let i = 0; i < this.buffer.numberOfChannels; i++) {
            // Cast to any to avoid TS mismatch between Float32Array<ArrayBufferLike> and Float32Array<ArrayBuffer>
            this.buffer.copyToChannel(BufferAudioData._emptySound as any, i);
          }
        }
      } catch (err) {
        //ignore
      }
      this.buffer = null;
      this._shouldBeDisposed = false;
    }
  }
}
